export const allHobbies = [
	{ name: "Art", icon: "bi-palette" },
	{ name: "Ceramics", icon: "bi-cup" },
	{ name: "Cooking", icon: "bi-egg-fried" },
	{ name: "Crafting", icon: "bi-scissors" },
	{ name: "Comedy", icon: "bi-emoji-laughing" },
	{ name: "Dancing", icon: "bi-music-note-list" },
	{ name: "Drawing", icon: "bi-pencil" },
	{ name: "Fitness", icon: "bi-bar-chart" },
	{ name: "Fishing", icon: "bi-water" },
	{ name: "Football", icon: "bi-circle-fill" },
	{ name: "Gardening", icon: "bi-flower3" },
	{ name: "Gaming", icon: "bi-controller" },
	{ name: "Hiking", icon: "bi-tree" },
	{ name: "Internet Dating", icon: "bi-heart" },
	{ name: "Languages", icon: "bi-translate" },
	{ name: "Meeting People", icon: "bi-people" },
	{ name: "Movies", icon: "bi-film" },
	{ name: "Music", icon: "bi-music-note" },
	{ name: "Painting", icon: "bi-palette" },
	{ name: "Padel", icon: "bi-circle" },
	{ name: "Photography", icon: "bi-camera" },
	{ name: "Reading", icon: "bi-book" },
	{ name: "Running", icon: "bi-stopwatch" },
	{ name: "Shopping", icon: "bi-cart" },
	{ name: "Social Media", icon: "bi-globe" },
	{ name: "Sport", icon: "bi-activity" },
	{ name: "Swimming", icon: "bi-droplet" },
	{ name: "Tennis", icon: "bi-activity" },
	{ name: "Water Sports", icon: "bi-snow" },
	{ name: "Writing", icon: "bi-pencil" },
	{ name: "YouTube", icon: "bi-youtube" },
	{ name: "Yoga", icon: "bi-heart-pulse" },
];
